@if (candidatura()) {
<div class="drawer-header border-bottom">
    <div class="d-flex align-items-center gap-2">
        <span class="title">Detalhes da candidatura</span>
        <span class="cand-code-badge" style="font-family: monospace; font-size: 0.85rem; padding: 0.2rem 0.55rem; border-radius: 4px; background: #e0f2fe; color: #0369a1; font-weight: 600;">{{ codigoLegivel }}</span>
    </div>
    <p-button (onClick)="closeModal()" icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" />
</div>
<div class="content-drawer p-4">

    <div class="basic-info">
        <div class="avatar">
            <p-avatar
                *ngIf="!imageError && empresaLogoUrl; else defaultEmpresaAvatar"
                [image]="empresaLogoUrl"
                shape="circle"
                size="xlarge"
                (onImageError)="imageError = true"
            />
            <ng-template #defaultEmpresaAvatar>
                <p-avatar
                    [label]="getInitials(candidatura()?.profissional?.nome || candidaturaData?.vaga?.empresa?.nome || candidatura()?.nomeEmpresa)"
                    [icon]="!(candidatura()?.profissional?.nome || candidaturaData?.vaga?.empresa?.nome) ? 'pi pi-user' : undefined"
                    shape="circle"
                    size="xlarge"
                />
            </ng-template>
        </div>
        <div class="details">
            <h3 class="name">{{ candidatura()?.profissional?.nome || 'Candidato' }}</h3>
            <span class="vaga-subtitle" style="font-size: 0.9rem; color: #64748b; display: flex; align-items: center; gap: 0.35rem; margin-top: 0.2rem;">
                <i class="pi pi-briefcase" style="font-size: 0.85rem;"></i>
                {{ candidaturaData?.vaga?.designacaoFuncao || candidatura()?.nomeEmpresa || 'Candidatura à vaga' }}
            </span>
        </div>
        <div *ngIf="candidatura()?.estadoCandidatura !== 'Contratado'">
            <p-splitbutton (onClick)="ToggleStatusCandidatura()" [label]="labelButton" [model]="items">
            </p-splitbutton>
        </div>

    </div>

    @if (candidaturaRemovida) {
    <div class="alert-banner alert-banner--danger" style="margin-top: 1rem; display: flex; align-items: flex-start; gap: 0.75rem; padding: 0.75rem 1rem; border-radius: 8px; background: #fef2f2; border: 1px solid #fecaca; color: #991b1b;">
        <i class="pi pi-exclamation-triangle" style="font-size: 1.25rem; margin-top: 0.15rem;"></i>
        <div>
            <div style="font-weight: 700;">Candidatura Removida</div>
            <div style="font-size: 0.875rem;" *ngIf="motivoRemocao"><strong>Motivo:</strong> {{ motivoRemocao }}</div>
            <div style="font-size: 0.875rem;" *ngIf="!motivoRemocao">Esta candidatura foi cancelada/removida.</div>
        </div>
    </div>
    }

    <div class="d-flex justify-content-between gap-3 mt-3">
        <div class="card-info flex-1">
            <div class="icon">
                <i class="pi pi-check-circle" style="color: #2563eb;"></i>
            </div>
            <div class="description">
                <span class="title">Estado</span>
                <p-tag [value]="candidatura()?.estadoCandidatura"
                    [severity]="getSeverityCandidatura(candidatura()?.estadoCandidatura)"></p-tag>
            </div>
        </div>
        <div class="card-info flex-1">
            <div class="icon">
                <i class="pi pi-calendar" style="color: #059669;"></i>
            </div>
            <div class="description">
                <span class="title">Data Candidatura</span>
                <span class="info">{{ candidatura()?.dataCandidatura }}</span>
            </div>
        </div>
        @if (anosExperiencia !== null) {
        <div class="card-info flex-1">
            <div class="icon">
                <i class="pi pi-briefcase" style="color: #7c3aed;"></i>
            </div>
            <div class="description">
                <span class="title">Experiência</span>
                <span class="info">{{ anosExperiencia }} {{ anosExperiencia === 1 ? 'ano' : 'anos' }}</span>
            </div>
        </div>
        }
    </div>

    <p-tabs value="0">
        <p-tablist>
            <p-tab value="0">
                <div class="tab-icon">
                    <img src="icons/clock.svg" alt="Email Icon" />
                </div>
                Histórico
            </p-tab>
            <p-tab value="1">
                <div class="tab-icon">
                    <img src="icons/users-01.svg" alt="Email Icon" />
                </div>
                Candidato
            </p-tab>
            <p-tab value="2">
                <div class="tab-icon">
                    <img src="icons/briefcase-02.svg" alt="Email Icon" />
                </div>
                Vaga
            </p-tab>
            <p-tab value="3">
                <div class="tab-icon">
                    <i class="pi pi-file" style="font-size: 0.95rem; color: #0284c7;"></i>
                </div>
                Documentos
                @if (documentosEmFalta.length > 0) {
                <p-tag severity="warn" [value]="documentosEmFalta.length + ' em falta'" styleClass="ml-2" />
                }
            </p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="0">

                <div class="viewStoy">
                    <p-timeline [value]="candidaturaStory">
                        <ng-template #opposite let-event>
                            <span class="text_desc">{{ event.dataFormatada }}</span>
                        </ng-template>
                        <ng-template #content let-event>
                            <div class="container_desc">
                                <span class="text_desc">{{ event?.historicoJson?.estadoCandidaturaDescricao }}</span>
                                <p-button label="Ver" />
                            </div>
                        </ng-template>
                    </p-timeline>
                </div>
            </p-tabpanel>

            <p-tabpanel value="1">

                <div class="d-flex gap-3 mt-4">
                    <div class="icon d-flex justify-content-center align-items-center rounded bg--primary-subtle p-2">
                        <i class="pi pi-user"></i>
                    </div>
                    <span>{{candidatura()?.profissional?.nome}}</span>
                </div>
                <div class="d-flex gap-3 mt-3">
                    <div class="icon d-flex justify-content-center align-items-center rounded bg--primary-subtle p-2">
                        <i class="pi pi-envelope"></i>
                    </div>
                    <span>{{candidatura()?.profissional?.email}}</span>
                </div>
                <div class="d-flex gap-3 mt-3">
                    <div class="icon d-flex justify-content-center align-items-center rounded bg--primary-subtle p-2">
                        <i class="pi pi-phone"></i>
                    </div>
                    <span>{{candidatura()?.profissional?.telefonePrincipal}}</span>
                </div>

                <div class="about mt-4">
                    <span class="title">Formação acadêmica</span>
                    @for (item of listaHabilitacoes; track $index) {
                    <div class="education-card mt-3">
                        <p-avatar icon="pi pi-graduation-cap" shape="circle" size="large" styleClass="flex-shrink-0" />
                        <div class="info">
                            <span class="course">{{item.designacao}}</span>
                            <span class="institution">{{item.instituicao}}</span>
                            <span class="period">{{item.dataInicio | date:'dd-MM-yyyy'}} - {{item.dataFim |
                                date:'dd-MM-yyyy'}}</span>
                        </div>
                    </div>
                    }
                </div>

                <div class="about mt-4">
                    <span class="title">Histórico profissional</span>
                    @for (item of listaExperiencias; track $index) {
                    <div class="education-card mt-3">
                        <p-avatar icon="pi pi-briefcase" shape="circle" size="large" styleClass="flex-shrink-0" />
                        <div class="info">
                            <span class="course">{{item.designacaoFuncao}}</span>
                            <span class="institution">{{item.nomeEmpresa}}</span>
                            <span class="period">
                                {{item.dataInicio | date:'dd-MM-yyyy'}} - {{item.isActualEmprego ? "até ao momento." :
                                (item.dataFim | date:'dd-MM-yyyy')}}
                            </span>
                            <!-- <p>
                                {{item.descricao}}
                            </p> -->
                        </div>
                    </div>
                    }
                </div>

                <div class="about mt-4">
                    <span class="title">Sobre o candidato</span>
                    <p>{{candidatura()?.profissional?.sobreMim}}</p>
                </div>

                @if (cartaApresentacao) {
                <div class="about mt-4">
                    <span class="title">Carta de apresentação</span>
                    <p style="white-space: pre-wrap; line-height: 1.6; background: var(--p-surface-50, #f8fafc); padding: 1rem; border-radius: 8px; border: 1px solid var(--p-surface-200, #e2e8f0); margin-top: 0.5rem;">
                        {{ cartaApresentacao }}
                    </p>
                </div>
                }

            </p-tabpanel>

            <p-tabpanel value="2">
                <div class="d-flex gap-3 mt-4">
                    <div class="icon d-flex justify-content-center align-items-center rounded bg--primary-subtle p-2">
                        <i class="pi pi-calendar"></i>
                    </div>
                    <span>{{candidaturaData?.vaga?.dataEncerramento | date:'dd-MM-yyyy'}}</span>
                </div>
                <div class="d-flex gap-3 mt-3">
                    <div class="icon d-flex justify-content-center align-items-center rounded bg--primary-subtle p-2">
                        <i class="pi pi-briefcase"></i>
                    </div>
                    <span>{{candidaturaData?.vaga?.designacaoFuncao || vagaDetail?.modelo}}</span>
                </div>
                <div class="d-flex gap-3 mt-3">
                    <div class="icon d-flex justify-content-center align-items-center rounded bg--primary-subtle p-2">
                        <i class="pi pi-map-marker"></i>
                    </div>
                    <span>{{candidaturaData?.vaga?.localizacao || vagaDetail?.localizacao}}</span>
                </div>

                <div class="about mt-4">
                    <span class="title">Sobre a vaga</span>
                    <p>{{candidaturaData?.vaga?.descricao || vagaDetail?.descricao}}</p>
                </div>

            </p-tabpanel>

            <p-tabpanel value="3">
                @if (documentosEmFalta.length > 0) {
                <div style="border: 1px solid #fde68a; background: #fffbeb; border-radius: 8px; padding: 1rem; margin-bottom: 1.25rem;">
                    <div class="d-flex align-items-center gap-2 mb-2" style="color: #92400e; font-weight: 600;">
                        <i class="pi pi-exclamation-triangle"></i>
                        <span>Documentos Exigidos em Falta ({{ documentosEmFalta.length }})</span>
                    </div>
                    <p style="font-size: 0.85rem; color: #78350f; margin-bottom: 0.5rem;">
                        Esta vaga exige os seguintes tipos de documentos que não foram anexados nesta candidatura:
                    </p>
                    <div class="d-flex flex-wrap gap-2">
                        @for (doc of documentosEmFalta; track doc.rotulo) {
                        <span style="display: inline-flex; align-items: center; gap: 0.35rem; padding: 0.25rem 0.65rem; border-radius: 9999px; background: #fef3c7; border: 1px solid #fcd34d; color: #b45309; font-size: 0.8rem; font-weight: 600;">
                            <i class="pi pi-times-circle"></i> {{ doc.rotulo }}
                        </span>
                        }
                    </div>
                </div>
                }

                @if (listaAnexos.length > 0) {
                <div class="documents-section">
                    <h4 style="font-size: 1rem; font-weight: 600; margin-bottom: 0.85rem; color: var(--p-text-color, #1e293b);">
                        Anexos Submetidos ({{ listaAnexos.length }})
                    </h4>
                    <div class="d-flex flex-column gap-2">
                        @for (anexo of listaAnexos; track anexo.id; let idx = $index) {
                        <div style="display: flex; align-items: center; justify-content: space-between; padding: 0.85rem 1rem; border: 1px solid var(--p-surface-200, #e2e8f0); border-radius: 8px; background: var(--p-surface-0, #ffffff);">
                            <div style="display: flex; align-items: center; gap: 0.85rem;">
                                <div style="width: 2.5rem; height: 2.5rem; border-radius: 6px; background: #e0f2fe; display: flex; align-items: center; justify-content: center; color: #0284c7;">
                                    <i [class]="anexo.mimeType?.includes('pdf') || anexo.extensao === '.pdf' ? 'pi pi-file-pdf' : (anexo.mimeType?.includes('image') || anexo.extensao === '.png' || anexo.extensao === '.jpg' || anexo.extensao === '.jpeg' ? 'pi pi-image' : 'pi pi-file')" style="font-size: 1.25rem;"></i>
                                </div>
                                <div>
                                    <div style="font-weight: 600; font-size: 0.95rem; color: var(--p-text-color, #1e293b);">
                                        {{ anexo.tipoAnexoCandidaturaDescricao || rotuloTipoAnexo(anexo.tipoAnexoCandidaturaEnum) }}
                                    </div>
                                    <div style="font-size: 0.8rem; color: var(--p-text-muted-color, #64748b); display: flex; gap: 0.5rem; align-items: center;">
                                        <span *ngIf="anexo.extensao">{{ anexo.extensao }}</span>
                                        <span *ngIf="anexo.dataCadastro">· {{ anexo.dataCadastro | date:'dd/MM/yyyy HH:mm' }}</span>
                                    </div>
                                </div>
                            </div>
                            <p-button label="Ver" icon="pi pi-eye" size="small" [outlined]="true" (onClick)="abrirPreview(anexo, idx)" />
                        </div>
                        }
                    </div>
                </div>
                } @else {
                <div class="text-center p-4 text-muted" style="border: 1px dashed var(--p-surface-300, #cbd5e1); border-radius: 8px; margin-top: 1rem;">
                    <i class="pi pi-folder-open" style="font-size: 2rem; color: #94a3b8; display: block; margin-bottom: 0.5rem;"></i>
                    <span>Nenhum anexo submetido nesta candidatura.</span>
                </div>
                }
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>

</div>
<p-toast></p-toast>
<p-confirmdialog>
    <ng-template #message let-message>
        <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
            <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
            <p>{{ message.message }}</p>
        </div>
    </ng-template>
</p-confirmdialog>

<app-documento-preview-modal
    [(visible)]="mostrarPreview"
    [documentos]="anexosParaPreview"
    [(indiceAtual)]="indicePreview"
    [permitirAcoes]="false"
/>

}